<template>
  <SimplePageLayout :city="city" title="Short-term rental licenses">
    <div class="p-3 overflow-auto h-100">
      <div v-if="error" class="alert alert-danger" role="alert">{{ error.message }}</div>
      <SpinnerView v-if="loading" />
      <template v-else-if="city">
        <div v-if="!licenses.length && !error" class="p-3">No public licenses on this page.</div>
        <table v-else-if="licenses.length" class="table">
          <thead>
            <tr>
              <th>License number</th>
              <th>Property address</th>
              <th>Status</th>
              <th>Issued</th>
              <th>Expires</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="license in licenses" :key="license.id">
              <td>{{ license.data.licenseId }}</td>
              <td>{{ formatAddress(license.data.address) }}</td>
              <td>{{ license.data.status }}</td>
              <td>{{ license.data.issuedOn || '—' }}</td>
              <td>{{ license.data.expiresOn || '—' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex gap-2">
          <button
            class="btn btn-outline-primary"
            :disabled="!cursors.length"
            @click="previous"
          >Previous</button>
          <button
            class="btn btn-outline-primary"
            :disabled="!nextCursor"
            @click="next"
          >Next</button>
        </div>
      </template>
    </div>
  </SimplePageLayout>
</template>

<script>
import SimplePageLayout from '@/components/common/SimplePageLayout.vue';
import SpinnerView from '@/components/common/SpinnerView.vue';
import { PublicCity } from '@/models/PublicCity';
import { fetchApi } from '@/api';

export default {
  components: {
    SimplePageLayout,
    SpinnerView
  },
  props: { cityId: String },
  data: () => ({
    city: null,
    licenses: [],
    loading: true,
    error: null,
    cursor: null,
    cursors: [],
    nextCursor: null,
    sequence: 0
  }),
  watch: {
    cityId: {
      immediate: true,

      handler() {
        this.cursor = null;
        this.cursors = [];
        this.load();
      }
    }
  },
  methods: {
    formatAddress(address) {
      if (typeof address === 'string') {
        return address;
      }

      return (
        address?.label ||
        [address?.streetNumber, address?.street, address?.unit].filter(Boolean).join(' ')
      );
    },

    async load() {
      const sequence = ++this.sequence;
      this.loading = true;
      this.error = null;
      this.licenses = [];
      this.nextCursor = null;

      try {
        const city = await PublicCity.load(this.cityId);
        const result = await fetchApi(
          `/v1/public/cities/${encodeURIComponent(this.cityId)}/licenses${
            this.cursor ? `?after=${encodeURIComponent(this.cursor)}` : ''
          }`
        );
        if (sequence === this.sequence) {
          this.city = city;
          this.licenses = result.licenses;
          this.nextCursor = result.nextCursor;
        }
      } catch (error) {
        if (sequence === this.sequence) {
          this.error = error;
        }
      } finally {
        if (sequence === this.sequence) {
          this.loading = false;
        }
      }
    },

    next() {
      this.cursors.push(this.cursor);
      this.cursor = this.nextCursor;
      this.load();
    },

    previous() {
      this.cursor = this.cursors.pop();
      this.load();
    }
  }
};
</script>
